export function validoi(data) {

    let msg
    if (data == null || data == undefined || data == "") {
        msg = "Nimi puuttuu"
    }

    else if (vainKirjaimia(data) == false) {
        msg = "Nimessä saa olla vain kirjaimia tai väliviivoja (-)"
    }

    else if (data.length < 2) {
        msg = "Nimessä on oltava vähintään 2 merkkiä"
    }

    else {
        msg = 'ok'
    }
    return msg

}

function vainKirjaimia(input) {
    // console.log("vainkirjaimia, ", input);
    if (input == null || input == undefined || input == "") {
        return false
    }

    let matches = input.match(/\p{L}|-| /gu);//palauttaa taulukon ehtoon (==kirjain) natsaavista merkeistä (ks. https://stackoverflow.com/questions/23136947/javascript-regex-to-return-letters-only)
    if (matches == undefined) {//kaikki merkit numeroita
        return false
    }
    else if (input.length == matches.length) {//kaikki merkit olivat kirjaimia
        return true
    } else return false

}











